import {ApiClient} from '@hconnect/apiclient'
import {useQuery} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {mapPlantStatusFromDto} from '../../mappers'
import {KpisQueryKey, PlantStatus, PlantStatusResponse} from '../../types'

const QueryKeyPrefix = KpisQueryKey.KpiDashboardPlantStatus
const INTERVAL_PERIOD_IN_MS = 300000

type TimeRange = {
  startDate: string
  endDate: string
}

export const usePlantStatus = (plantId: string, dateRange: TimeRange) => {
  return useQuery<PlantStatusResponse, AxiosError, PlantStatus>({
    queryKey: [QueryKeyPrefix, plantId, dateRange],
    queryFn: async ({signal}) => {
      const response = await ApiClient.axiosInstance.post<PlantStatusResponse>(
        `/kpi/dashboard/plants/${plantId}`,
        dateRange,
        {signal}
      )

      return response.data
    },
    refetchInterval: INTERVAL_PERIOD_IN_MS,
    select: mapPlantStatusFromDto
  })
}
